import { useMemo } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { CourseSet } from "../../types/requirement.response";
import { getCourseKey } from "../../utils/courseUtils";
import { getCourseSetSlotInfo } from "../../utils/requirementResponseUtils";
import HeaderCourseChip from "./HeaderCourseChip";
import HeaderAddCourse from "./HeaderAddCourse";

interface HeaderCourseSetSlotsProps {
    courseSet: CourseSet;
    coursesMap: Record<string, CourseSummary>;
    requirementId: string;
    onAdd: (course: AddableCourse) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
    isBroad?: boolean;
}

export default function HeaderCourseSetSlots({ courseSet, coursesMap, requirementId, onAdd, onDelete, isBroad }: HeaderCourseSetSlotsProps) {
    const { appliedCourses, unappliedCourses, allCourses, emptySlotCount, label } = useMemo(
        () => getCourseSetSlotInfo(courseSet, coursesMap),
        [courseSet, coursesMap]
    );

    return (
        <>
            {appliedCourses.map(({ course, isApplied }) => (
                <HeaderCourseChip
                    key={getCourseKey(course)}
                    course={course}
                    isApplied={isApplied}
                    nodeId={courseSet.id}
                    requirementId={requirementId}
                    onDelete={onDelete}
                />
            ))}
            {Array.from({ length: emptySlotCount }, (_, i) => (
                <HeaderAddCourse
                    key={`add-${courseSet.id}-${i}`}
                    allCourses={allCourses}
                    onAdd={onAdd}
                    label={label}
                    nodeId={courseSet.id}
                    dropId={`header-group-slot-${courseSet.id}-${i}`}
                    isBroad={isBroad}
                />
            ))}
            {unappliedCourses.map(({ course, isApplied }) => (
                <HeaderCourseChip
                    key={getCourseKey(course)}
                    course={course}
                    isApplied={isApplied}
                    nodeId={courseSet.id}
                    requirementId={requirementId}
                    onDelete={onDelete}
                />
            ))}
        </>
    );
}
